var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.00032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, "\n                  {\" \"}\n                  ", /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }), "{\" \"}\n                  ", /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2v25.6h26.667v-25.6h-26.667zM1.067 19.307l7.467-7.84 7.413 7.413 3.733-3.2 5.547 5.653h-24.16v-2.027zM25.6 27.733h-24.533v-5.333h24.533v5.333zM25.6 20.213l-5.813-6.027-3.733 3.2-7.52-7.467-7.467 7.84v-13.493h24.533v15.947z",
    fill: "var(--text-color)"
  }, "\n                    {\" \"}\n                  "), "{\" \"}\n                  ", /*#__PURE__*/React.createElement("path", {
    d: "M19.733 11.733c1.493 0 2.667-1.173 2.667-2.667s-1.173-2.667-2.667-2.667c-1.493 0-2.667 1.173-2.667 2.667s1.173 2.667 2.667 2.667zM19.733 7.467c0.907 0 1.6 0.693 1.6 1.6s-0.693 1.6-1.6 1.6c-0.907 0-1.6-0.693-1.6-1.6s0.693-1.6 1.6-1.6z",
    fill: "var(--text-color)"
  }, "\n                    {\" \"}\n                  "), "{\" \"}\n                ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFile);
export default __webpack_public_path__ + "static/media/bannerFile.a24e6141de728724648bdda4dceb3ce9.svg";
export { ForwardRef as ReactComponent };